import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import axios from "axios";
import VueAxios from 'vue-axios'
import './assets/style/theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css';
import qs from 'qs'


Vue.use(ElementUI);
// 定义全局点击函数
Vue.prototype.globalClick = function (callback) {
  document.getElementById('main').onclick = function () {
    callback();
  };
};
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.prototype.$qs = qs;
axios.defaults.baseURL = "/zhongqinchina";
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
